import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Gallery } from './components/Gallery';
import { FAQ } from './components/FAQ';
import { CTASection, Footer } from './components/CTAFooter';
import AdminPage from './pages/AdminPage';
import { PrivacyPage, TermsPage } from './pages/LegalPage';
import UnsubscribePage from './pages/UnsubscribePage';

const HomePage = () => (
  <div className="App min-h-screen bg-[#FFFDF8] text-stone-900">
    <Navbar />
    <main>
      <Hero />
      <Features />
      <Gallery />
      <FAQ />
      <CTASection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
